





























































































































































































import { Watch, Component, Vue, Inject, Ref } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { RealworksStatusRuleAPI, RealworksKenmerkAPI } from '@/api/backend-client'
import { namespace } from 'vuex-class'
import CreatePhaseStatusSideSheet from '@/components/virtual-colleague/phase-status/CreatePhaseStatusSideSheet.vue'
const realworksStatusRules = namespace('realworksStatusRule')

@Component
export default class CompanySettingsRealworksStatusRule extends Vue {
    @realworksStatusRules.State readonly loading!: boolean
    @realworksStatusRules.State readonly realworksStatusRules!: RealworksStatusRule[]
    @realworksStatusRules.State readonly totalItems!: number
    @realworksStatusRules.State readonly totalPages!: number
    @realworksStatusRules.State readonly page!: number
    @realworksStatusRules.State readonly orderField!: string|null
    @realworksStatusRules.State readonly orderDirection!: string|null
    @realworksStatusRules.Action applyCompanyFilter: (payload: { query: string }) => Promise<void>
    @realworksStatusRules.Action nextPage: () => Promise<void>
    @realworksStatusRules.Action prevPage: () => Promise<void>
    @realworksStatusRules.Action applyOrder: ({ field, direction }) => Promise<void>
    @Inject() readonly reloadCompany: () => Promise<void>
    @Ref() phaseStatusSideSheet: CreatePhaseStatusSideSheet
    realworksKenmerken: any = {}

    created() {
        this.onRouteChange()
    }

    async reload() {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })
        this.$forceUpdate()
    }

    @Watch('$route')
    async onRouteChange(): Promise<void> {
        await this.applyCompanyFilter({
            query: this.$currentCompany.id,
        })

        await this.getKenmerken()
    }

    async goToRealworksStatusRuleDetail(realworksStatusRule: RealworksStatusRule): Promise<void> {
        this.phaseStatusSideSheet.openWithExisting(realworksStatusRule)
    }

    async goToRealworksStatusRuleCreate(): Promise<void> {
        this.phaseStatusSideSheet.open()
    }

    generateHeaderClasses(field: string) {
        return {
            'sortable': true,
            'sorted': this.orderField === field,
            'sorted--asc': this.orderField === field && this.orderDirection === 'asc',
            'sorted--desc': this.orderField === field && this.orderDirection === 'desc',
        }
    }

    changeOrder(field: string, direction: string) {
        if (this.orderField === field) {
            direction = this.orderDirection === 'asc' ? 'desc' : 'asc'
        }

        this.applyOrder({
            field,
            direction,
        })
    }

    async deleteRealworksStatusRule(realworksStatusRule) {
        if (confirm(this.$t('company_settings.realworks_status_rules.delete_confirm').toString())) {
            await RealworksStatusRuleAPI.delete(realworksStatusRule.id)
            await this.reloadCompany()
        }
    }

    async getKenmerken() {
        const realworksKenmerken = {}

        const kenmerken = await RealworksKenmerkAPI.getAll()
        for (const kenmerk of kenmerken) {
            realworksKenmerken[kenmerk.id] = kenmerk.omschrijving
        }

        this.realworksKenmerken = realworksKenmerken
    }

    formatKenmerk(kenmerk: string): string {
        if (this.realworksKenmerken[kenmerk]) {
            return this.realworksKenmerken[kenmerk]
        }

        return kenmerk
    }

    formatReferralType(referralType: string): string {
        return this.$t('referral.type.' + referralType).toString()
    }

    formatStatus(status: string): string {
        if (this.$currentCompany.pipelinesEnabled) {
            return this.$t('referral.phaseModelStatus.' + status).toString()
        } else {
            return this.$t('referral.status.' + status).toString()
        }
    }

    formatStatusReason(statusReason: string): string {
        return this.$t('referral.statusReason.' + statusReason).toString()
    }
}
